module.exports = __webpack_public_path__ + "img/9788954643610.68601cc2.jpg";